import gql from 'graphql-tag';

const GET_ORGANISATION_QUERY = gql`
  query GetOrganisation($organisationId: String!)
  {
    getOrganisation(organisationId: $organisationId) {
      name
      brandingCoverImageKey
      imageUrl
      brandingDescription
      billingEntityCode
      shutterstockAccess
      contractUrl
      clientType
      creditBalance {
        balance
        creditTotal
        rolloverBalance
        rolloverTotal
      }
      alias
      package {
        iconName
        videoQuantity
        slaTurnaround
        userAllowance
        storageAllowance
        templatedFrom
        creditType
        subEnd
        includedAddonTypes
      }
      organisationProduct {
        organisationProductsId
        organisationId
        trial
        expiryDate
        product {
          productId
          shortName
          longName
        }
      }
    }
  }`;

export default ((organisationId) => ({
  query: GET_ORGANISATION_QUERY,
  module: 'organisations',
  ignoreCache: true,
  buildVariables: () => ({
    organisationId
  }),
  isSilent: true
}));